import {
  createAnalyticsClient,
  uncurlyUuid,
} from '@atlassian/bitkit-analytics';
import AnalyticsWebClient, {
  tenantType,
} from '@atlassiansox/analytics-web-client';

let globalAnalyticsClient: AnalyticsWebClient;

export const initAnalyticsClient = (): AnalyticsWebClient => {
  return createAnalyticsClient();
};

/**
 * Get the global analytics client, initializing it if it's the first time this
 * function is called.
 */
export const analyticsClient = (): AnalyticsWebClient => {
  if (!globalAnalyticsClient) {
    globalAnalyticsClient = initAnalyticsClient();
  }

  return globalAnalyticsClient;
};

/**
 * Whenever the workspace context changes we need to update the analytics
 * client. This may help provide more accurate analytics, but more importantly
 * we need to respect when a tenant says they don't want analytics collected.
 */
export const setWorkspace = (workspaceUuid: string | undefined): void => {
  const client = analyticsClient();
  if (workspaceUuid) {
    // We want to support optional braces for this function. If uncurlyUuid
    // returns an empty string for no braces, assume the given string is a
    // valid UUID format.
    const uuid = uncurlyUuid(workspaceUuid) || workspaceUuid;
    client.setTenantInfo(tenantType.CLOUD_ID, uuid);
    client.setWorkspaceInfo(uuid);
  } else {
    client.clearTenantInfo();
    client.clearWorkspaceInfo();
  }
};
